export const OverflowMenuCalendlyComponentModule = angular
    .module('app.components.pageHeader.overflowMenuCalendly', [])
    .component('overflowMenuCalendly', {
        template: `
            <md-menu-item class="overflow-menu-calendly">
                <calendly-button show-icon="false"></calendly-button>
            </md-menu-item>
        `
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuCalendly.js